import { render, staticRenderFns } from "./ShippingMethodActionReindex.vue?vue&type=template&id=6152aac6&"
import script from "./ShippingMethodActionReindex.vue?vue&type=script&lang=ts&"
export * from "./ShippingMethodActionReindex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports